/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

require("./select");

import Vue from "vue";

import "livewire-vue";
import axios from "axios";
Vue.prototype.$axios = axios;

// Vue Cookie Accept Decline
import VueCookieAcceptDecline from "vue-cookie-accept-decline";
Vue.component("vue-cookie-accept-decline", VueCookieAcceptDecline);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context("./", true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        key
            .split("/")
            .pop()
            .split(".")[0],
        files(key).default
    )
);

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
window.Vue = Vue;

const app = new Vue({
    el: "#app",

    data() {
        return {
            menuOpen: false,
            modalUserOpen: false,
            modalGenericErrorOpen: false,
            modalContactLegalInformation: false,
            type: "password",
            limitPosition: 500,
            scrolled: false,
            scrolledFilter: false,
            lastPosition: 0,
            showMenu: false,
            menuClose: true,
            modalResize: false,
            infoOpen: false,
            cartOpen: false,
            cartClose: true,
            showCart: false,
            serviceModal: false,
            serviceMealTimeModal: false,
            modalMbWay: false,
            modalPaymentError: false,
            serviceModalMobile: false,
            serviceZipCodeModal: false,
            serviceStoreModal: false,
            deliveryConfirmModal: false,
            deliveryErrorOnlyTakeawayModal: false,
            deliveryErrorNoProductModal: false
        };
    },
    methods: {
        menuClickHandler() {
            if (this.menuOpen == false) {
                this.menuOpen = !this.menuOpen;

                this.showMenu = !this.showMenu;

                this.menuClose = !this.menuClose;
            } else {
                this.menuOpen = !this.menuOpen;

                this.menuClose = !this.menuClose;

                setTimeout(() => (this.showMenu = !this.showMenu), 400);
            }
            document.querySelector("html").classList.toggle("no-scroll");

            document.querySelector("body").classList.toggle("no-scroll");
        },
        modalUserClickHandler() {
            this.modalUserOpen = !this.modalUserOpen;

            this.$root.$emit("reset-phone-field");
            this.$root.$emit("clear-form-errors");

            document.querySelector("html").classList.toggle("no-scroll");
            document.querySelector("body").classList.toggle("no-scroll");

            Livewire.emit("resetAuth");

            this.modalResize = false;
        },
        modalAlertClickHandler() {
            document.querySelector("html").classList.add("no-scroll");
            document.querySelector("body").classList.add("no-scroll");
        },
        modalGenericErrorHandler() {
            this.modalGenericErrorOpen = !this.modalGenericErrorOpen;

            if (this.modalGenericErrorOpen == true) {
                document.querySelector("html").classList.add("no-scroll");
                document.querySelector("body").classList.add("no-scroll");
            } else {
                document.querySelector("html").classList.remove("no-scroll");
                document.querySelector("body").classList.remove("no-scroll");
            }
        },
        modalContactLegalInformationHandler() {
            this.modalContactLegalInformation = !this
                .modalContactLegalInformation;

            if (this.modalContactLegalInformation == true) {
                document.querySelector("html").classList.add("no-scroll");
                document.querySelector("body").classList.add("no-scroll");
            } else {
                document.querySelector("html").classList.remove("no-scroll");
                document.querySelector("body").classList.remove("no-scroll");
            }
        },
        modalCartClickHandler() {
            if (this.cartOpen == false) {
                this.cartOpen = !this.cartOpen;

                this.showCart = !this.showCart;

                this.cartClose = !this.cartClose;
            } else {
                this.cartOpen = !this.cartOpen;

                this.cartClose = !this.cartClose;

                setTimeout(() => (this.showCart = !this.showCart), 400);
            }
            document.querySelector("html").classList.toggle("no-scroll");

            document.querySelector("body").classList.toggle("no-scroll");
        },
        serviceMealTimeModalHandler() {
            if (this.serviceMealTimeModal == false) {
                document
                    .getElementById("service-meal-time-modal")
                    .classList.add("show");
                document.querySelector("html").classList.add("no-scroll");
                document.querySelector("body").classList.add("no-scroll");
            } else {
                document
                    .getElementById("service-meal-time-modal")
                    .classList.remove("show");
                document.querySelector("html").classList.remove("no-scroll");
                document.querySelector("body").classList.remove("no-scroll");
            }
            this.serviceMealTimeModal = !this.serviceMealTimeModal;
        },
        serviceModalHandler() {
            if (this.serviceModal == false) {
                document.getElementById("service-modal").classList.add("show");
                document.querySelector("html").classList.add("no-scroll");
                document.querySelector("body").classList.add("no-scroll");
            } else {
                document
                    .getElementById("service-modal")
                    .classList.remove("show");
                document.querySelector("html").classList.remove("no-scroll");
                document.querySelector("body").classList.remove("no-scroll");
            }
            this.serviceModal = !this.serviceModal;
        },
        serviceZipCodeModalHandler() {
            if (this.serviceZipCodeModal == false) {
                document
                    .getElementById("service-zipcode-modal")
                    .classList.add("show");
                document.querySelector("html").classList.add("no-scroll");
                document.querySelector("body").classList.add("no-scroll");
            } else {
                document
                    .getElementById("service-zipcode-modal")
                    .classList.remove("show");
                document.querySelector("html").classList.remove("no-scroll");
                document.querySelector("body").classList.remove("no-scroll");
            }
            this.serviceZipCodeModal = !this.serviceZipCodeModal;
        },
        serviceStoreModalHandler() {
            if (this.serviceStoreModal == false) {
                document
                    .getElementById("service-store-modal")
                    .classList.add("show");
                document.querySelector("html").classList.add("no-scroll");
                document.querySelector("body").classList.add("no-scroll");
            } else {
                document
                    .getElementById("service-store-modal")
                    .classList.remove("show");
                document.querySelector("html").classList.remove("no-scroll");
                document.querySelector("body").classList.remove("no-scroll");
            }
            this.serviceStoreModal = !this.serviceStoreModal;
        },
        deliveryConfirmModalHandler() {
            if (this.deliveryConfirmModal == false) {
                document
                    .getElementById("delivery-confirm-modal")
                    .classList.add("show");
                document.querySelector("html").classList.add("no-scroll");
                document.querySelector("body").classList.add("no-scroll");
            } else {
                document
                    .getElementById("delivery-confirm-modal")
                    .classList.remove("show");
                document.querySelector("html").classList.remove("no-scroll");
                document.querySelector("body").classList.remove("no-scroll");
            }
            this.deliveryConfirmModal = !this.deliveryConfirmModal;
        },
        deliveryErrorOnlyTakeawayModalHandler() {
            if (this.deliveryErrorOnlyTakeawayModal == false) {
                document
                    .getElementById("delivery-error-takeaway-only-modal")
                    .classList.add("show");
                document.querySelector("html").classList.add("no-scroll");
                document.querySelector("body").classList.add("no-scroll");
            } else {
                document
                    .getElementById("delivery-error-takeaway-only-modal")
                    .classList.remove("show");
                document.querySelector("html").classList.remove("no-scroll");
                document.querySelector("body").classList.remove("no-scroll");
            }
            this.deliveryErrorOnlyTakeawayModal = !this
                .deliveryErrorOnlyTakeawayModal;
        },
        deliveryErrorNoProductModalHandler() {
            if (this.deliveryErrorNoProductModal == false) {
                document
                    .getElementById("delivery-error-no-product")
                    .classList.add("show");
                document.querySelector("html").classList.add("no-scroll");
                document.querySelector("body").classList.add("no-scroll");
            } else {
                document
                    .getElementById("delivery-error-no-product")
                    .classList.remove("show");
                document.querySelector("html").classList.remove("no-scroll");
                document.querySelector("body").classList.remove("no-scroll");
            }
            this.deliveryErrorNoProductModal = !this
                .deliveryErrorNoProductModal;
        },
        handleScroll() {
            if (window.scrollY > 80) {
                this.scrolled = true;
            } else {
                this.scrolled = false;
            }
            // original source: https://codepen.io/kode88/pen/XRpXej
        },
        smoothScrollFilterMenu() {
            document.querySelectorAll('a[href^="#"]').forEach(a => {
                a.addEventListener("click", function(e) {
                    e.preventDefault();
                    const href = this.getAttribute("href");
                    const elem = document.querySelector(href);
                    const nextState = {
                        additionalInformation: "Updated the URL hash with JS"
                    };
                    window.history.pushState(nextState, href, "/carta/" + href);
                    if (window.innerWidth <= 1023) {
                        window.scroll({
                            top: elem.offsetTop + 78,
                            left: 0,
                            behavior: "smooth"
                        });
                    } else {
                        window.scroll({
                            top: elem.offsetTop + 140,
                            left: 0,
                            behavior: "smooth"
                        });
                    }
                });
            });
        },
        trackingFilterMenu() {
            let fromTop = window.scrollY;

            let mainNavLinks = document.querySelectorAll(
                ".filters .js-scroll-step > a"
            );
            mainNavLinks.forEach(link => {
                let section = document.querySelector(link.hash);

                if (section == null) {
                    return;
                }

                if (
                    section.offsetTop - 78 <= fromTop &&
                    section.offsetTop - 78 + section.offsetHeight > fromTop
                ) {
                    link.parentElement.classList.add("selected");
                } else {
                    link.parentElement.classList.remove("selected");
                }
            });
        },
        tooltipHandler(event) {
            if (this.infoOpen == false) {
                const targetId = event.currentTarget.id;
                const refs = document.querySelector(
                    `[data-tooltip*=` + CSS.escape(targetId) + `]`
                );
                refs.classList.toggle("more-info-open");
            } else {
                const div = document.querySelector("more-info-open");
                div.classList.remove("more-info-open");
            }
        },
        resizeModal() {
            this.modalResize = true;
        }
    },
    created() {
        window.addEventListener("scroll", this.handleScroll);

        window.addEventListener("scroll", this.trackingFilterMenu);

        this.$root.$on("open-accordion-payment", () => {
            window.scrollTo(0, 0);
        });

        window.addEventListener("afterCartStoreChange", event => {
            this.$root.$emit("updateCartStore", event);
        });

        window.addEventListener("afterCartZipCodeChange", event => {
            /*
                Quando escolhe 1 código postal no auto complete tanto no header como no carrinho
                é disparado afterCartZipCodeChange com as seguintes props:
                zipCodeSelected -> zipcode seleccionado
                addressesOptions -> opções default do utilizador
                slotsOptions
                slotsSelected
            */
            this.$root.$emit("updateCartZipCodeOptions", event);
        });

        window.addEventListener("afterCartSavedAddressZipCodeChange", event => {
            /*
                Quando escolhe 1 dos valores default do user tanto no header como no carrinho
                é disparado afterCartSavedAddressZipCodeChange com as seguintes props:
                zipCodeSelected -> zipcode seleccionado
                slotsOptions
                slotsSelected
            */
            this.$root.$emit("updateCartSavedAddress", event);
        });

        window.addEventListener("afterCartDateChange", event => {
            this.$root.$emit("updateCartSlots", event);
        });

        Livewire.on("menuClickHandler", () => this.menuClickHandler());

        Livewire.on("serviceModalHandler", () => this.serviceModalHandler());
        Livewire.on("serviceMealTimeModalHandler", () =>
            this.serviceMealTimeModalHandler()
        );
        Livewire.on("serviceZipCodeModalHandler", () =>
            this.serviceZipCodeModalHandler()
        );
        Livewire.on("serviceStoreModalHandler", () =>
            this.serviceStoreModalHandler()
        );
        Livewire.on("deliveryConfirmModalHandler", () =>
            this.deliveryConfirmModalHandler()
        );
        Livewire.on("deliveryErrorOnlyTakeawayModalHandler", () =>
            this.deliveryErrorOnlyTakeawayModalHandler()
        );
        Livewire.on("deliveryErrorNoProductModalHandler", () =>
            this.deliveryErrorNoProductModalHandler()
        );
        Livewire.on("modalCartClickHandler", () =>
            this.modalCartClickHandler()
        );

        Livewire.on("closeAuthModal", () => this.modalUserClickHandler());

        Livewire.on("resizeAlert", () => this.resizeModal());

        Livewire.on("modalGenericErrorHandler", () =>
            this.modalGenericErrorHandler()
        );

        Livewire.on("modalContactLegalInformationHandler", () =>
            this.modalContactLegalInformationHandler()
        );

        Livewire.on("afterClearCartDefered", (cartContent) => {
            setTimeout(() => {
                Livewire.emit("resetLoading", '');
                Livewire.emit('afterClearCart', cartContent);
            }, 1000);
        });

    },

    mounted() {
        this.smoothScrollFilterMenu();
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);

        window.removeEventListener("scroll", this.trackingFilterMenu);
    }
});
